import { Link } from 'react-router-dom'
import type { OverflowItem } from '@/components/navbar/navItems'
import { CardSingleIcon, CardMultipleIcon, EyeOpenIcon, EyeClosedIcon } from '@/icons'
import { useFilterStore } from '@/store/filterStore'

const linkStyles = 'block px-4 py-2 text-sm font-medium rounded-md'
const activeLinkStyles = 'bg-elevated text-primary'
const inactiveLinkStyles = 'text-secondary hover:bg-hover hover:text-primary'

export const menuToggleStyles =
  'w-full flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-md transition-colors'
export const inactiveToggleStyles = 'text-secondary hover:bg-hover hover:text-primary'
const collapseActiveStyles = 'bg-blue-600 text-white hover:bg-blue-700'
const hiddenActiveStyles = 'bg-yellow-600 text-white hover:bg-yellow-700'

export function MenuLink({ item, active, onClose }: { item: OverflowItem; active: boolean; onClose: () => void }) {
  return (
    <Link
      to={item.to as string}
      onClick={onClose}
      role="menuitem"
      aria-current={active ? 'page' : undefined}
      className={`${linkStyles} ${active ? activeLinkStyles : inactiveLinkStyles}`}
    >
      {item.label}
    </Link>
  )
}

function CollapseMenuToggle() {
  const { collapseVariants, toggleCollapseVariants } = useFilterStore()

  return (
    <button
      onClick={() => {
        toggleCollapseVariants()
      }}
      role="menuitemcheckbox"
      aria-checked={collapseVariants}
      className={`${menuToggleStyles} ${collapseVariants ? collapseActiveStyles : inactiveToggleStyles}`}
    >
      {collapseVariants ? <CardMultipleIcon className="w-4 h-4" /> : <CardSingleIcon className="w-4 h-4" />}
      {collapseVariants ? 'Player Mode' : 'Collector Mode'}
    </button>
  )
}

function HiddenMenuToggle() {
  const { showHidden, toggleShowHidden } = useFilterStore()

  return (
    <button
      onClick={() => {
        toggleShowHidden()
      }}
      role="menuitemcheckbox"
      aria-checked={showHidden}
      className={`${menuToggleStyles} ${showHidden ? hiddenActiveStyles : inactiveToggleStyles}`}
    >
      {showHidden ? <EyeOpenIcon className="w-4 h-4" /> : <EyeClosedIcon className="w-4 h-4" />}
      {showHidden ? 'Showing Hidden' : 'Hidden Filtered'}
    </button>
  )
}

/** The menu control for a toggle item, or null for an unknown id. */
export function MenuToggle({ id }: { id: string }) {
  if (id === 'collapse-toggle') return <CollapseMenuToggle />
  if (id === 'hidden-toggle') return <HiddenMenuToggle />
  return null
}
